<template>
    <section id="product" class="product">
        <div class="container">
            <h3 class="product-title">{{ $t('products.main_title') }}</h3>
            <div class="product-content">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="card" v-scrollanimation>
                            <h4 class="title">{{$store.state.product_data[0].title}}</h4>
                            <div class="disc">{{$store.state.product_data[0].details}}</div>
                            <div class="img">
                                <img
                                    :src="$store.state.product_data[0].main_media"
                                    style="width: 70%"
                                    :alt="$store.state.product_data[0].title"
                                    height="100%"
                                    width="100%"
                                />
                            </div>
                            <div>
                                <!-- <button
                                    @click="viewDetails(data[0].id)"
                                    class="my-button3"
                                    style="margin: 0px;margin-bottom: 0px"
                                >{{ $t('view_details') }}</button>-->
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="card right" v-scrollanimation>
                            <h4 class="title">{{$store.state.product_data[1].title}}</h4>
                            <div class="disc">{{$store.state.product_data[1].details}}</div>
                            <div class="img">
                                <img
                                    :src="$store.state.product_data[1].main_media"
                                    style="width: 70%"
                                    :alt="$store.state.product_data[1].title"
                                    height="100%"
                                    width="100%"
                                />
                            </div>
                            <div>
                                <!-- <button
                                    @click="viewDetails(data[1].id)"
                                    class="my-button3"
                                    style="margin: 0px;margin-bottom: 0px"
                                >{{ $t('view_details') }}</button>-->
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-6">
                        <div class="card" v-scrollanimation>
                            <h4 class="title">{{ $store.state.product_data[2].title }}</h4>
                            <div class="disc">{{ $store.state.product_data[2].details }}</div>
                            <div class="img">
                                <img
                                    :src="$store.state.product_data[2].main_media"
                                    style="width: 90%"
                                    :alt="$store.state.product_data[2].title"
                                    height="100%"
                                    width="100%"
                                />
                            </div>
                            <div>
                                <!-- <button
                                    @click="viewDetails(data[2].id)"
                                    class="my-button3"
                                    style="margin: 0px;margin-bottom: 0px"
                                >{{ $t('view_details') }}</button>-->
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="card right" v-scrollanimation>
                            <h4 class="title">{{ $store.state.product_data[3].title }}</h4>
                            <div class="disc">{{ $store.state.product_data[3].details }}</div>
                            <div class="img">
                                <img
                                    :src="$store.state.product_data[3].main_media"
                                    style="width: 90%"
                                    :alt="$store.state.product_data[3].title"
                                    height="100%"
                                    width="100%"
                                />
                            </div>
                            <div>
                                <!-- <button
                                    @click="viewDetails(data[3].id)"
                                    class="my-button3"
                                    style="margin: 0px;margin-bottom: 0px"
                                >{{ $t('view_details') }}</button>-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "product",
    data() {
        return {
            slide: 0,
            sliding: null,
            data: [],
            // data: [
            //     {
            //         id: 1,
            //         title: "PeakLink Academy",
            //         desc: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Totam asperiores maiores porro voluptates quas ad excepturi rem, voluptatem minus error exercitationem.",
            //         main_media: "Academy.png",
            //     },
            //     {
            //         id: 2,
            //         title: "PeakLink Clinic",
            //         desc: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Totam asperiores maiores porro voluptates quas ad excepturi rem, voluptatem minus error exercitationem.",
            //         main_media: "Clinic.png",
            //     },
            //     {
            //         id: 3,
            //         title: "PeakLink ERP",
            //         desc: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Totam asperiores maiores porro voluptates quas ad excepturi rem, voluptatem minus error exercitationem.",
            //         main_media: "ERP.png",
            //     },
            //     {
            //         id: 4,
            //         title: "PeakLink HR",
            //         desc: "Lorem ipsum dolor sit amet consectetur, adipisicing elit. Totam asperiores maiores porro voluptates quas ad excepturi rem, voluptatem minus error exercitationem.",
            //         main_media: "HR.png",
            //     },
            // ],
        };
    },
    methods: {
        getmain_media(item) {
            return require("@/assets/img/product/" + item.main_media)
        },
        onSlideStart(slide) {
            this.sliding = true
        },
        onSlideEnd(slide) {
            this.sliding = false
        },
        viewDetails(id) {
            // this.$router.replace({ name: 'product', params: { id: id } })
        }
    },
    mounted() {
        this.data = this.$store.state.product_data
        console.log(this.data)
    }
};
</script>

<style lang="scss">
.product {
    padding: 80px 0px;
    background-color: rgba(231, 231, 231, 0.356);
}

.product .product-title {
    text-align: center;
    font-size: 35px;
    font-weight: bold;
    color: var(--main-blue);
    margin-bottom: 60px;
}

.product .title {
    color: var(--main-green);
    font-size: 25px;
    // font-weight: 800;
}

.product .card {
    padding: 30px;
    text-align: justify;
    border: none;
    box-shadow: 0 0 10px #0000002e;
    border-radius: 20px;
    // height: 500px;
    transition: all 0.7s;
}

.product .disc {
    color: gray;
}
.product .img {
    display: flex;
    justify-content: center;
    margin-top: 40px;
    transition: all 0.5s;
}

@media (min-width: 992px) {
    .product .right {
        margin-top: 60px;
    }
}

@media (max-width: 991px) {
    .product .right {
        margin-top: 0px;
    }
    .product .card {
        margin-bottom: 50px;
    }
}

.product .card:hover {
    transform: translateY(-30px);
    transition: all 0.7s;
    .img {
        transform: translateY(-20px);
        transition: all 0.5s;
    }
}

.my-button3 {
    position: relative;
    color: var(--main-green);
    font-size: 16px;
    // font-weight: bold;
    text-decoration: none;
    margin: 30px 0;
    border: 1px solid var(--main-green);
    padding: 12px 30px;
    overflow: hidden;
    transition: 0.6s all ease;
    background: transparent;
    border-radius: 10px;
    z-index: 100000;
}

.my-button3::before {
    background: var(--main-green);
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: -1;
    transition: all 0.6s ease;
}

.my-button3:hover {
    color: #fff;
}

.my-button3::before {
    width: 0%;
    height: 102%;
}

.my-button3:hover::before {
    width: 102%;
}

.product .before-enter {
    opacity: 0;
    transform: translateY(100px);
    transition: all 1s ease-out;
}

.product .enter {
    opacity: 1;
    transform: translateY(0px);
}
</style>